// UI texts: map
export default {
  title: 'World map',
  who: '{name} · Lv {n}',
  season: 'Season {n}',
  daysLeft: '{n} days left',
  dayLeft: 'last day',
  online: '{n} survivors out there',
  aboveLevel: 'Above your level ({n})',
  camp: 'Camp',
  unknown: '???',
  openPvp: 'Open PvP',
  secret: 'Secret',
  here: '{n} survivors here',
  hereShort: '{n} here',
  lvPlus: 'Lv {n}+',
  /** B4 (1. 10. 2026): the compact label of a zone locked by level. */
  lvShort: 'Lv {n}',
  /** Krug 5 (K4.11). */
  unlocksAt: 'Unlocks at Lv {n}',
  newlyOpen: 'New',
  /** Krug 5 (K4.8). */
  tougher: 'Recommended level {r}. Enemies here are tougher for you (+{n}%).',
  /** 6. 10. 2026: a zone above the level, but the survivor's Power is enough (no penalty). */
  strongEnough: "Recommended level {r}. You're strong enough for this zone.",
  discoveredBy: 'Discovered by {name}',
  markers: { rumor: 'Rumor', horde: 'Horde attack', clan: 'Held by the survivor group {name} [{tag}]: +10% loot here for its members', wanted: 'Wanted here: {names}' },
  /** Package 4, part E (9): the zone panel's row. */
  wantedHere: 'Wanted here: {names}. Beat them for {n} Relic Shards and a big bounty.',
  horde: {
    live: 'Horde attacking {zone}',
    boss: '{title} at {zone}',
    join: 'Join',
  },
  events: 'World events',
  clearsIn: 'clears in {t}',
  // Zone detail
  close: 'Close',
  danger: 'Danger {n}/5',
  recLevel: 'Rec. level',
  you: 'You: {n}',
  duration: 'Duration',
  energy: 'Energy',
  ofEnergy: 'you have {n}',
  pickEnergy: '{n} energy',
  pickLoot: '~{n} resources',
  pickItem: '{n}% gear drop',
  /** B2 / B7 (1. 10. 2026): the durations as information, and the estimate for the one the order sheet starts on. */
  min: 'min',
  estimateFor: '{d}:',
  /** C1: the key a run into a found secret zone uses. */
  entry: 'Entry: {n} {key}',
  entryHave: 'you have {n}',
  entryFree: 'Entry: free, you found it',
  loot: 'Possible loot',
  topRarity: 'Up to {rarity}',
  topRarityNote: 'Gear drops here go up to {rarity}.',
  enemies: 'Enemies',
  /** Package 4, part 0: without a zone; the zone panel names them by zone (`enemyShow`). */
  enemy: { infected: 'Infected', raider: 'Tollmen', mutant: 'Mutants', drone: 'WARDEN drones', survivor: 'Survivors', boss: 'Boss' },
  activeNow: 'Survivors active now:',
  pvpSimilar: 'PvP: similar power only',
  pvpOpen: 'OPEN PvP: anyone',
  controlledBy: 'Held by the survivor group {name} [{tag}]',
  controlBonus: 'Its members get +10% loot here',
  controlBonusMine: '+10% loot for your group',
  modifiers: 'Active modifiers',
  modLoot: 'Loot {v}',
  modDanger: 'Danger {v}',
  modDuration: 'Runs take {v} longer',
  modDurationShort: 'Runs are {v} shorter',
  rumor: 'Rumor: fresh tracks, better finds right now',
  hordeHere: 'A horde is attacking this zone',
  hordeLink: 'To the defense',
  lockedStamp: 'Locked',
  lockedTitle: 'Not reachable yet',
  secretStamp: 'Secret',
  prepare: 'Prepare expedition',
  viewExpedition: 'View expedition',
  outNote: 'Your survivor is already out there.',
  emptyTitle: 'The map is blank',
  emptyBody: 'No zones came back from the server. Try again in a moment.',
} as const;
